import type {
  GroupMeetingManage,
  GroupMeetingManageDto,
  GroupMeetingManageTeacherScoreDto,
} from "meetings/group-meeting/types";
import type { TeacherScore } from "meetings/shared/types";

const teacherScoreFromDto = (
  dto: GroupMeetingManageTeacherScoreDto,
): TeacherScore => ({
  teacherShortage: dto.teacher_shortage,
  total: dto.total,
  filled: dto.filled,
  percentage: dto.total > 0 ? Math.round((dto.filled / dto.total) * 100) : 0,
});

export const groupMeetingManageFromDto = (
  dto: GroupMeetingManageDto,
): GroupMeetingManage => ({
  id: dto.id,
  name: dto.name,
  message: dto.message,
  status: dto.status,
  teacherPercentage: dto.teacher_percentage,
  mentorClasses: [...dto.mentor_classes],
  ratingTypeIds: [...dto.rating_type_ids],
  ratingTypes: dto.rating_types.map((ratingType) => ({ ...ratingType })),
  teacherIds: Object.fromEntries(
    Object.entries(dto.teacher_ids).map(([mentorClass, teacherIds]) => [
      mentorClass,
      [...teacherIds],
    ]),
  ),
  hasGivenFeedback: dto.has_given_feedback,
  teacherScores: dto.teacher_scores.map(teacherScoreFromDto),
  totalGivenRatings: dto.total_given_ratings,
  totalRatings: dto.total_ratings,
  opensAtDate: dto.timeframe_settings.opens_at_date,
  opensAtTime: dto.timeframe_settings.opens_at_time,
  closedNoModifyDate: dto.timeframe_settings.closed_no_modify_at_date,
  closedNoModifyTime: dto.timeframe_settings.closed_no_modify_at_time,
  archivedDate: dto.timeframe_settings.archived_at_date,
  archivedTime: dto.timeframe_settings.archived_at_time,
  meetingDates: dto.timeframe_settings.meeting_dates.map(
    ({ start_date, start_time, end_date, end_time }) => ({
      start_date,
      start_time,
      end_date,
      end_time,
    }),
  ),
});
